import { render, staticRenderFns } from "./PaperAgendaItem.vue?vue&type=template&id=ac365a4c&scoped=true&"
import script from "./PaperAgendaItem.vue?vue&type=script&lang=js&"
export * from "./PaperAgendaItem.vue?vue&type=script&lang=js&"
import style0 from "./PaperAgendaItem.vue?vue&type=style&index=0&id=ac365a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac365a4c",
  null
  
)

export default component.exports